.component {
    width: 100%;
}
